export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/permissions/store/state.js